module.exports = __webpack_public_path__ + "img/cgal-05.3d01297a.jpg";